// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class SoundTheoryGuidanceCatalog {
    static SoundTheoryOverviewModule: IGuidanceTopic = {
        name: "SoundTheory_Overview",
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/Overview.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Sound Theory Help",
    };

    static SoundTheoryGS1Module: IGuidanceTopic = {
        name: "SoundTheory_Q1", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720044470/T1+What+is+the+difference+between+Airborne+Structure+borne+sound
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T1DifferenceAirborneAndStructurebourneSound.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is the difference between Airborne & Structure borne sound?",
        catchwords: ["Holography"],
    };
    static SoundTheoryGS2Module: IGuidanceTopic = {
        name: "SoundTheory_Q2", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720044470/T1+What+is+the+difference+between+Airborne+Structure+borne+sound
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T2PressurePowerIntensitySound.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,

        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "Sound Pressure, Sound Power, and Sound Intensity: What’s the difference?",
        catchwords: [""],
        hidden: true,
    };
    static SoundTheoryGS3Module: IGuidanceTopic = {
        name: "SoundTheory_Q3", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175438/T3+What+is+Natural+Frequency+and+Resonance
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T3NaturalFrequencyResonance.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is Natural Frequency and Resonance?",
        catchwords: [""],
        hidden: true,
    };
    static SoundTheoryGS4Module: IGuidanceTopic = {
        name: "SoundTheory_Q4", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175460/T4+How+does+the+decibel+scale+work
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T4HowDoesTheDecibelScaleWork.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How does the decibel scale work?",
        catchwords: [""],
        hidden: true,
    };
    static SoundTheoryGS5Module: IGuidanceTopic = {
        name: "SoundTheory_Q5", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175501/T5+What+is+A-Weighting
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T5WhatIsAWeighting.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is A-Weighting?",
        catchwords: [""],
        hidden: true,
    };
    static SoundTheoryGS6Module: IGuidanceTopic = {
        name: "SoundTheory_Q6", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175663/T6+What+is+the+difference+between+plane+waves+and+Spherical+waves
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T6PlaneWavesSphericalWavesDifference.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is the difference between plane waves and Spherical waves?",
        catchwords: [""],
        hidden: true,
    };
    static SoundTheoryGS7Module: IGuidanceTopic = {
        name: "SoundTheory_Q7", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720044579/T7+What+is+the+difference+between+Near+Field+and+Far+Field
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T7NearfieldFarfieldDifference.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What is the difference between Near Field and Far Field?",
        catchwords: [""],
    };
    static SoundTheoryGS8Module: IGuidanceTopic = {
        name: "SoundTheory_Q8", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720699525/T8+What+are+white+noise+and+pink+noise+How+and+why+to+generate+these
        modulePath: PLATFORM.moduleName("guidance/SoundTheory/T8WhiteAndPinkNoise.html"),
        title: "Sound Theory",
        moduleType: WorkflowModuleType.Help,
        topicParent: SoundTheoryGuidanceCatalog.SoundTheoryOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "What are white noise and pink noise? How and why to generate these?",
        catchwords: [""],
        hidden: true,
    };
}
